import { Fragment, useEffect } from "react";
import {
  Nav,
  NavItem,
  TabContent,
  TabPane,
  NavLink,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Container,
  FormGroup,
  Input,
  InputGroup,
  Label,
  Row,
  Form,
  FormFeedback,
} from "../../components/Common/AppOverlay";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { SuccessNotify, ErrorNotify } from "../../shared/Alert";
import {
  getCompanyRelatedList,
  getCompanyDetails,
  getCompanyList,
} from "../../helpers/backend_helper";
import * as url from "../../helpers/url_helper";
import { getData, postData, postRawData } from "../../helpers/url-request";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import classnames from "classnames";
import * as Yup from "yup";
import { useFormik } from "formik";
import { showLoading } from "react-global-loading";
import CompanyDetail from "../Company/CompanyDetail";
import CompanyFullDetail from "../Company/CompanyFullDetail";
import {
  ColumnDirective,
  ColumnsDirective,
  GridComponent,
  Page,
  Inject,
  Sort,
  Edit,
  ColumnMenu,
  CommandColumn,
  Toolbar,
  ExcelExport,
  PdfExport,
  Resize,
} from "../../components/Common/LegacyGridAdapter";

// Formik validation

const CompanySelectionList = (props) => {
  let gridInstance;

  const [relatedCompanies, setRelatedCompanies] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [detailId, setDetailId] = useState(0);
  const [detailOpen, setDetailOpen] = useState(false);

  const selectionSettings = { type: "Multiple", checkboxOnly: true };

  useEffect(() => {
    loadData();
  }, []);

  const toggleDetail = () => {
    setDetailOpen(!detailOpen);
  };

  const onDetailClose = () => {
    toggleDetail();
    loadData();
  };

  const loadData = () => {
    showLoading(true);

    getCompanyList()
      .then((res) => {
        if (res.status) {
          setCompanies(res.data);
        } else {
          ErrorNotify(res.message);
        }
      })
      .catch((err) => {
        console.log(err);
        showLoading(false);
        ErrorNotify("Error occured while fetching data");
      });

    getCompanyRelatedList(props.companyId)
      .then((res) => {
        showLoading(false);
        if (res.status) {
          setRelatedCompanies(res.data);
        } else {
          ErrorNotify(res.message);
        }
      })
      .catch((err) => {
        console.log(err);
        showLoading(false);
        ErrorNotify("Error occured while fetching data");
      });
  };

  const headerLink = (props) => {
    return (
      <a
        onClick={() => viewDetail(props.id)}
        color="primary"
        className="btn-link"
        style={{ cursor: "pointer" }}
      >
        {props.name}
      </a>
    );
  };

  const viewDetail = (departmentId) => {
    setDetailId(departmentId);
    toggleFullDetail();
  };

  const statusTemplate = (props) => {
    return (
      <div>
        {props.status === 1 ? (
          <div className="statustemp e-activecolor">
            <span className="statustxt e-activecolor">Active</span>
          </div>
        ) : (
          <div className="statustemp e-inactivecolor">
            <span className="statustxt e-inactivecolor">Inactive</span>
          </div>
        )}
      </div>
    );
  };

  const toolbarOptions = ["Search"];

  const onSubmit = () => {
    if (gridInstance.getSelectedRecords()) {
      var ids = [];

      gridInstance.getSelectedRecords().map((data) => {
        console.log(data.id);
        ids.push(data.id);
      });

      var _data = {
        companyId: props.companyId,
        relatedIds: ids,
      };

      postData("/company/addrelated", _data)
        .then((res) => {
          showLoading(false);
          if (res.status == true) {
            SuccessNotify("Data saved successfully");
            onDetailClose();
          } else {
            ErrorNotify(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
          showLoading(false);
          ErrorNotify("Error occured while saving data");
        });
    }
  };

  return (
    <React.Fragment>
      <div className="d-flex flex-row-reverse">
        <Button
          type="button"
          className="btn btn-success waves-effect waves-light"
          to="#"
          onClick={toggleDetail}
          color="success"
        >
          <i className="bx bx-plus font-size-16 align-middle me-2"></i> Add
          Department
        </Button>
      </div>
      <Row>
        <Col xl={12}>
          <GridComponent
            dataSource={relatedCompanies}
            allowTextWrap={true}
            allowSorting={true}
            allowResizing={true}
            statelessTemplates={["directiveTemplates"]}
            allowPaging={true}
            showColumnMenu={true}
            pageSettings={{
              pageSize: 15,
              pageSizes: ["5", "10", "15", "20", "25", "All"],
            }}
          >
            <ColumnsDirective>
              <ColumnDirective
                field="name"
                headerText="Name"
                template={headerLink}
              ></ColumnDirective>
              <ColumnDirective
                field="address"
                headerText="Address"
              ></ColumnDirective>
              <ColumnDirective
                field="contactNo"
                headerText="Contact No."
                width="100"
              ></ColumnDirective>
              <ColumnDirective
                field="emailId"
                headerText="Email Id"
                width="100"
              />
              <ColumnDirective
                field="status"
                headerText="Status"
                template={statusTemplate}
                width="110"
              />
              <ColumnDirective
                field="updatedOn"
                type="datetime"
                format="dd/MM/yyyy h:mm a"
                headerText="Last Updated"
                width="115"
              />
            </ColumnsDirective>
            <Inject services={[Sort, Page, ColumnMenu, Resize]} />
          </GridComponent>
        </Col>
      </Row>

      <Offcanvas
        backdrop={true}
        className="w-50"
        direction="end"
        isOpen={detailOpen}
        toggle={toggleDetail}
      >
        <OffcanvasHeader toggle={toggleDetail} className="canvasHeader">
          Department Details
        </OffcanvasHeader>
        <OffcanvasBody>
          <Row>
            <Col sm="12" className="mb-3">
              <GridComponent
                dataSource={companies}
                ref={(grid) => (gridInstance = grid)}
                allowTextWrap={true}
                allowSorting={true}
                allowResizing={true}
                statelessTemplates={["directiveTemplates"]}
                selectionSettings={selectionSettings}
                toolbar={toolbarOptions}
                allowPaging={false}
                showColumnMenu={true}
              >
                <ColumnsDirective>
                  <ColumnDirective type="checkbox" width="50"></ColumnDirective>
                  <ColumnDirective
                    field="name"
                    headerText="Name"
                  ></ColumnDirective>
                  <ColumnDirective
                    field="address"
                    headerText="Address"
                  ></ColumnDirective>
                  <ColumnDirective
                    field="contactNo"
                    headerText="Contact No."
                    width="100"
                  ></ColumnDirective>
                  <ColumnDirective
                    field="emailId"
                    headerText="Email Id"
                    width="100"
                  />
                </ColumnsDirective>
                <Inject services={[Sort, ColumnMenu, Resize]} />
              </GridComponent>
            </Col>
            <div>
              <Button
                color="primary"
                className="btn btn-success me-4"
                type="button"
                onClick={onSubmit}
              >
                Submit
              </Button>
              <Button
                className="btn btn-light"
                color="secondary"
                type="button"
                onClick={onDetailClose}
              >
                Close
              </Button>
            </div>
          </Row>
        </OffcanvasBody>
      </Offcanvas>
    </React.Fragment>
  );
};

export default CompanySelectionList;
